import * as React from 'react';
import { useCallback } from 'react';

import { CheckoutOrderFragment, ExchangeOrderFragment } from '@websky/graphql';
import { ExchangeRefundCreateForm, ExchangeRefundCustomer } from '@entities/order';

import { useCreateExchange } from '../../model/useCreateExchange';

interface Props {
	className?: string;
	title?: string;
	description?: string;
	initialValues?: ExchangeRefundCustomer;
	isRequiredComment?: boolean;
	order?: CheckoutOrderFragment;
	onSuccess?: (exchangeOrder: ExchangeOrderFragment) => void;
}

const CreateExchangeForm: React.FC<Props> = ({
	className,
	title,
	description,
	initialValues,
	isRequiredComment,
	order,
	onSuccess
}) => {
	const { onCreateExchange, isLoading } = useCreateExchange();

	const onSubmit = useCallback(
		(data: ExchangeRefundCustomer) => {
			onCreateExchange({ createExchangeParams: data, onSuccess });
		},
		[onSuccess, onCreateExchange]
	);

	return (
		<ExchangeRefundCreateForm
			type="exchange"
			className={className}
			title={title}
			description={description}
			initialValues={initialValues}
			isLoading={isLoading}
			requiredComment={isRequiredComment}
			order={order}
			onSubmit={onSubmit}
		/>
	);
};

export default CreateExchangeForm;
